import {createTheme} from "@mui/material/styles";

export default createTheme({
    components: {
        MuiCircularProgress: {
            styleOverrides: {
                root: {
                    '&.send_message_loader': {
                        color: '#e0e8e0',
                        maxWidth: '24px',
                        maxHeight: '24px',
                    },
                },
            },
        },
        
        MuiTextField: {
            styleOverrides: {
                root: {
                    color: '#1565c0',
                    borderRadius: '2px',
                    borderWidth: '1px',
                    borderColor: '#2196f3',
                    border: '1px solid',
                    backgroundColor: '#90caf9',
                }
            }
        },
        
        MuiPaginationItem: {
            styleOverrides: {
                root: {
                    color: '#072C37',
                    fontFamily: "Onest",
                    fontWeight: 500,
                    fontSize: 18,
                    minWidth: 20,
                    width: "56px",
                    height: "56px",
                    border: "1px solid #072C37",
                    borderRadius: "60px",
                    
                    '@media (max-width: 620px)': {
                        width: "40px",
                        height: "40px",
                    },
                    
                    '@media (max-width: 354px)': {
                        width: "36px",
                        height: "36px",
                    },
                    
                    '&.Mui-selected, &.Mui-disabled': {
                        background: 'transparent',
                        color: '#AFCBBC',
                        border:" 1px solid #AFCBBC",
                        opacity: 1,
                        pointerEvents: "none",
                        
                        "&:hover": {
                            backgroundColor: "transparent",
                        },
                    },
                    
                    
                    "&:hover": {
                        backgroundColor: "#E8EDEA",
                        
                    },
                    
                },
                
                ellipsis: {
                    border: "none",
                    pointerEvents:"none",
                    height: "auto",
                    fontSize: "20px",
                    width:"30px"
                }
            },
            
            
        },
    }
})